import { render } from "./CategoryEdit.vue?vue&type=template&id=5209b950"
import script from "./CategoryEdit.vue?vue&type=script&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__